import avatar1 from "../images/avatar/avatar-1.jpg";
import btcImg from "../images/currency/btc.svg";
import avatar2 from "../images/avatar/avatar-2.jpg";
import avatar3 from "../images/avatar/avatar-3.jpg";
import ethImg from "../images/currency/eth.svg";
import avatar4 from "../images/avatar/avatar-4.jpg";
import avatar5 from "../images/avatar/avatar-5.jpg";
import avatar6 from "../images/avatar/avatar-6.jpg";
import avatar7 from "../images/avatar/avatar-7.jpg";

export const userList = [
  {
    id: 1,
    user: 'Cory',
    avatar: avatar1,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 2,
    user: 'Cory',
    avatar: avatar2,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 3,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 4,
    user: 'Cory',
    avatar: avatar4,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 5,
    user: 'Cory',
    avatar: avatar5,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 6,
    user: 'Cory',
    avatar: avatar6,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 7,
    user: 'Cory',
    avatar: avatar7,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 8,
    user: 'Cory',
    avatar: avatar2,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 9,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 10,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
]
export const highWinsList = [

  {
    id: 6,
    user: 'Cory',
    avatar: avatar6,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 7,
    user: 'Cory',
    avatar: avatar7,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 8,
    user: 'Cory',
    avatar: avatar2,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 9,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 10,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
]
export const luckyWinsList = [
  {
    id: 1,
    user: 'Cory',
    avatar: avatar1,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 2,
    user: 'Cory',
    avatar: avatar2,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 3,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 6,
    user: 'Cory',
    avatar: avatar6,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 7,
    user: 'Cory',
    avatar: avatar7,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 8,
    user: 'Cory',
    avatar: avatar2,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: btcImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 9,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
  {
    id: 10,
    user: 'Cory',
    avatar: avatar3,
    game: 'King’s Mask',
    time: '3:33 PM',
    amount: '$397.00',
    amountImg: ethImg,
    mult: '3.00x',
    payout: '$1191.00'
  },
]